// 9fbef606107a605d69c0edbcd8029e5d
import Styled, { css } from 'styled-components';

export const Ratings = Styled.p`
  display: inline-block;
  font-size: 19px;
  line-height: 1rem;
  &:before {
    content: '★★★★★';
    letter-spacing: 2px;
    background: ${(props) =>
      css`linear-gradient(90deg, ${
        props.isTileRedesignAB ? `${props?.theme?.colors?.TEXT?.DARKERGRAY}` : '#fc0'
      } ${(props.value / 5) * 100}%, #d8d8d8 ${(props.value / 5) * 100}%)`};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      letter-spacing: 0.6px;
    }

  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 16px;
  }
`;

export const ReviewCount = Styled.span`
  display: inline-block;
  font-family: Nunito;
  font-weight: 400;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgb(155, 155, 155);
  font-size: 12px;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 10px;
    padding: 0;
  }
`;

export const RatingsReviewsWrapper = Styled.div`
  padding: 1px 0;
`;
